'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;
var STATE_VARIANT_PREFIXES = [
  'hover',
  'focus',
  'active',
  'group-hover',
  'focus-within',
];
var _default = STATE_VARIANT_PREFIXES;
exports.default = _default;
